import { useEffect } from "react"

import { matchAdminSearchShortcut } from "../utils/admin-global-search-shortcut"

/**
 * Binds Ctrl/Cmd+K to open the admin global search palette.
 *
 * Always preventDefaults on a match so Chrome/Edge/Firefox cannot steal the
 * chord to the omnibox — including from inputs and while the palette is already
 * open (`onOpen` is idempotent). AltGr/Shift chords are rejected by
 * `matchAdminSearchShortcut`.
 *
 * There is no central hotkey registry in this app — every shortcut attaches its
 * own window listener — so this follows that convention rather than introducing
 * one. Ctrl/Cmd+K is free on the admin route: the only other binding lives in
 * `sidebar-search-button.tsx`, which mounts on the translator and parser
 * sidebars.
 *
 * @param enabled Detaches the listener while false.
 */
export function useAdminGlobalSearchShortcut(enabled: boolean, onOpen: () => void) {
  useEffect(() => {
    if (!enabled) return

    const handleKeyDown = (event: KeyboardEvent) => {
      if (!matchAdminSearchShortcut(event)) return
      event.preventDefault()
      onOpen()
    }

    window.addEventListener("keydown", handleKeyDown)
    return () => window.removeEventListener("keydown", handleKeyDown)
  }, [enabled, onOpen])
}
